import { getWithToken, postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const net_zero_tool = apiUrl + "/net_zero_tool";
const routes = {
  label: "Net Zero Tool",
  new: net_zero_tool + "/new",

  update: net_zero_tool + "/update",

  get_by_supply_chain_id_and_type: net_zero_tool + "/get_by_supply_chain_id_and_type",
  get_by_corporate_id_and_type: net_zero_tool + "/get_by_corporate_id_and_type",
  get_by_structure_id_and_type: net_zero_tool + "/get_by_structure_id_and_type",

  delete_by_ids: net_zero_tool + "/delete_by_ids",
};

export const NetZeroTool = {
  label: routes.label,

  /**
   *
   * @param {{supply_chain_id: string | null, corporate_id: string | null, structure_id: string | null,
   * type: string, action: string | null, category: string | null, year: number | null,
   * details: string | null, estimated_ghg: number | null}} net_zero_tool
   * @returns
   */
  new: (net_zero_tool) => postWithToken(routes.new, net_zero_tool),

  /**
   * @param {{id: string, type: string, action: string | null, category: string | null, year: number | null,
   * details: string | null, estimated_ghg: number | null}} net_zero_tool
   * @returns
   */
  update: (net_zero_tool) => postWithToken(routes.update, net_zero_tool),

  get_by_supply_chain_id_and_type: (supply_chain_id, type) => getWithToken(routes.get_by_supply_chain_id_and_type, { supply_chain_id, type }),
  get_by_corporate_id_and_type: (corporate_id, type) => getWithToken(routes.get_by_corporate_id_and_type, { corporate_id, type }),
  get_by_structure_id_and_type: (structure_id, type) => getWithToken(routes.get_by_structure_id_and_type, { structure_id, type }),

  delete_by_ids: (ids) => postWithToken(routes.delete_by_ids, { ids }),
};
